// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMTO59z7wr7QwX2XcVzMupWPM3yrnspfs",
  authDomain: "soka-jr-bad.firebaseapp.com",
  databaseURL: "https://soka-jr-bad-default-rtdb.firebaseio.com",
  projectId: "soka-jr-bad",
  storageBucket: "soka-jr-bad.appspot.com",
  messagingSenderId: "915591555827",
  appId: "1:915591555827:web:d91db9b800d07e91fd2586",
  measurementId: "G-MKDRXZN53R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase();
const analytics = getAnalytics(app);
const auth = getAuth();
const functions = getFunctions(app, 'asia-southeast1');

const isEmulating = window.location.hostname === "localhost";

if (isEmulating) {
  connectDatabaseEmulator(db, 'localhost', 9000); 
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export default { analytics, db, auth, functions };